import { ArrowUpRight } from "lucide-react";
import { EVENTS, waLink } from "@/data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const Events = () => (
  <section id="events" data-testid="events-section" className="bg-espresso grain relative py-24 md:py-36">
    <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10">
      <SectionHeading chapter="03" eyebrow="Events We Cater" title="Every Occasion," script="beautifully served." dark />

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {EVENTS.map((e, i) => (
          <Reveal key={e.title} delay={(i % 3) * 0.1} className={i % 3 === 1 ? "lg:mt-12" : ""}>
            <a
              data-testid={`event-card-${e.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              href={waLink(`Hi Momay Caterers, I'd like to plan catering for a ${e.title} event. Please share menus and details.`)}
              target="_blank"
              rel="noopener noreferrer"
              className="group block relative overflow-hidden aspect-[3/4]"
            >
              <img
                src={e.img}
                alt={`${e.title} catering by Momay Caterers Kutch`}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover scale-105 group-hover:scale-100 transition-transform duration-[1.4s] ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-espresso via-espresso/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
                <h3 className="font-serif text-2xl md:text-3xl text-cream tracking-wide">{e.title.toUpperCase()}</h3>
                <p className="mt-2 text-cream/70 text-sm font-light leading-relaxed max-w-xs">{e.desc}</p>
                <span className="mt-4 inline-flex items-center gap-2 text-gold text-xs tracking-[0.25em] uppercase transition-transform duration-300 group-hover:translate-x-1">
                  Plan This Event <ArrowUpRight size={14} />
                </span>
              </div>
              <span className="absolute inset-0 border border-cream/0 group-hover:border-gold/40 transition-colors duration-500 pointer-events-none" />
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
